import { Typography } from 'shared/ui'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { RE_ENROLL_OPTIONS } from '../../store/triggerWidgetStore'
import styles from './styles.module.scss'

type ITriggerStep4Props = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const TriggerStep4 = ({ focusedIndex, onSelect }: ITriggerStep4Props) => (
  <div className={styles.list}>
    {RE_ENROLL_OPTIONS.map((item, index) => (
      <WidgetItem
        key={item.id}
        isFocused={index === focusedIndex}
        badgeIndex={index}
        onClick={() => onSelect(index)}
      >
        <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
          {item.label}
        </Typography>
      </WidgetItem>
    ))}
  </div>
)
